// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"351":"e7343be9","578":"d6ce6297"}[chunkId] + ".chunk.js";
};